module.exports = __webpack_public_path__ + "static/media/flag-japan.04ef218e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/LanguageFlag/LanguageFlagIcons/flag-japan.svg
// module id = 1131
// module chunks = 1